import { getDoc, doc } from 'firebase/firestore';
import { Team } from 'functions/src/types/firestore/Game/Tournament/Guestlist';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { firestore } from 'src/config/firebaseClient';
import { useAuth } from 'src/contexts/AuthContext';
import { SignInGuard } from './SignInGuard';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';

export type InviteGuardProps = {
  gameId: string;
};

export const InviteGuard = ({ gameId }: InviteGuardProps) => {
  const [authGuardOpen, setAuthGuardOpen] = useState(false);
  const { user } = useAuth();

  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }
    const {
      inviteId = undefined,
      tournamentId: tournamentIds = undefined,
      ...rest
    } = router.query;
    const tournamentId = tournamentIds
      ? typeof tournamentIds === 'string'
        ? tournamentIds
        : tournamentIds[1]
      : undefined;
    if (!inviteId || !tournamentId || typeof inviteId !== 'string') {
      return;
    }
    setAuthGuardOpen(!user);
    if (!user || (!!user.email && !user.emailVerified)) {
      return;
    }

    const handler = async () => {
      const teamRef = doc(
        firestore,
        `Game/${gameId}/Tournament/${tournamentId}/Guestlist/${inviteId}`, // TODO: Handle waitlist as well
      ).withConverter(ConverterFactory.buildDateConverter<Team>());

      const teamDoc = await getDoc(teamRef);
      const team = teamDoc.data();
      if (!team) {
        return;
      }
      const captain = team.members.find(
        (member) => member.status === 'captain',
      );
      if (!captain) {
        return;
      }

      const { inviteTeamMember } = await import(
        '../../firebaseCloud/tournament/inviteTeamMember'
      );

      try {
        await inviteTeamMember({
          captainId: captain.userId,
          gameId,
          teamId: inviteId,
          tournamentId,
          invitedId: user.uid,
        });

        router.replace({ pathname: router.pathname, query: rest }, undefined, {
          shallow: true,
        });
      } catch (error) {
        console.error({ error });
      }
    };
    handler();
  }, [gameId, router, user]);

  return (
    <SignInGuard
      title={'Accept invite?'}
      open={authGuardOpen}
      onClose={() => setAuthGuardOpen(false)}
    />
  );
};
